module.exports = __webpack_public_path__ + "img/integra_logo.5935a453.png";